exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-Freeform {\n  max-width: 100%;\n}\n.cs-Freeform__question {\n  font-size: 18px;\n  margin: 20px;\n}\n.cs-Freeform__answerBox {\n  margin: 20px;\n}\n@media print {\n  .cs-Freeform__answerBox {\n    display: none;\n  }\n}\n.cs-Freeform__answerBox--print {\n  margin: 20px;\n}\n@media screen {\n  .cs-Freeform__answerBox--print {\n    display: none;\n  }\n}\n.form-control {\n  resize: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Freeform/Freeform.less
// module id = 886
// module chunks = 0